import type { ReactNode } from "react";

interface MainLayoutProps {
    children: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
    return (
        <div className="w-full flex-1 bg-gray-50 p-0 xs:px-6 pt-0">
            <div className="mx-auto w-full max-w-2xl">{children}</div>
        </div>
    );
};
